import { ErrorBoundary } from 'react-error-boundary'
import { ChakraProvider } from '@chakra-ui/react'
import { Toaster } from '@!/components/ui/toaster'
import { Provider } from 'jotai'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HashRouter } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie'

import { Fallback } from '@!/components/Error/Fallback'
import { system } from '@!/config/theme'
import { JotaiDevToolsProvider } from '@!/providers'

export const BaseProvider = (props) => {
  const queryClient = new QueryClient()
  return (
    <>
      <ErrorBoundary FallbackComponent={Fallback}>
        <ChakraProvider value={system}>
          <Toaster />
          <Provider store={props.jotaiStore}>
            <JotaiDevToolsProvider />
            <QueryClientProvider client={queryClient}>
              <CookiesProvider defaultSetOptions={{ path: '/', sameSite: 'strict' }}>
                <HashRouter>{props.children}</HashRouter>
              </CookiesProvider>
            </QueryClientProvider>
          </Provider>
        </ChakraProvider>
      </ErrorBoundary>
    </>
  )
}
